import { AuthLayout } from "../../components/domain/auth/AuthLayout";
import { ResetPasswordForm } from "../../components/domain/auth/ResetPasswordForm";
import { useResetPassword } from "./useResetPassword";

export default function ResetPassword() {
  const { password, setPassword, confirm, setConfirm, error, loading, invalidLink, handleSubmit } =
    useResetPassword();

  return (
    <AuthLayout>
      <ResetPasswordForm
        password={password}
        setPassword={setPassword}
        confirm={confirm}
        setConfirm={setConfirm}
        error={error}
        loading={loading}
        invalidLink={invalidLink}
        onSubmit={handleSubmit}
      />
    </AuthLayout>
  );
}
